module.exports = __webpack_public_path__ + "static/el-obrero-internacional-2-05286844e123fac1c8f0b755534080e2.png";